import React, { useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Mail, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';
import ContactFormModal from './ContactFormModal';

const CTASection = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [formType, setFormType] = useState('getStarted');

  const openModal = (type) => {
    setFormType(type);
    setIsContactModalOpen(true);
  };

  return (
    <>
      <section id="contact" className="py-24 bg-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-gradient-to-b from-slate-50 to-white" />
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" />
        
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="bg-slate-900 rounded-3xl p-12 md:p-16 relative overflow-hidden">
            {/* Background Decorations */}
            <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-teal-500/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" />
            <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-slate-700/50 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" />
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:3rem_3rem]" />
            
            <div className="relative z-10 text-center">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Ready to Build Something
                <span className="text-teal-400"> Great</span>?
              </h2>
              <p className="text-lg text-slate-300 max-w-2xl mx-auto mb-10">
                Let's discuss how {companyInfo.shortName} can help your business move faster and operate smarter through technology.
              </p>
              
              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
                <Button 
                  onClick={() => openModal('getStarted')}
                  className="bg-teal-500 hover:bg-teal-400 text-white px-8 py-6 text-lg rounded-xl transition-all duration-300 hover:shadow-xl hover:shadow-teal-500/25 group"
                >
                  Start Your Project
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button 
                  variant="outline" 
                  onClick={() => openModal('contact')}
                  className="border-2 border-slate-600 text-white hover:border-slate-500 hover:bg-slate-800 px-8 py-6 text-lg rounded-xl transition-all duration-300"
                >
                  Schedule a Call
                </Button>
              </div>

              {/* Contact Info */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-8 pt-8 border-t border-slate-700">
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-3 text-slate-300 hover:text-teal-400 transition-colors group"
                >
                  <div className="w-10 h-10 rounded-lg bg-slate-800 group-hover:bg-slate-700 flex items-center justify-center transition-colors">
                    <Mail className="w-5 h-5" />
                  </div>
                  <span>{companyInfo.email}</span>
                </a>
                <a 
                  href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                  className="flex items-center gap-3 text-slate-300 hover:text-teal-400 transition-colors group"
                >
                  <div className="w-10 h-10 rounded-lg bg-slate-800 group-hover:bg-slate-700 flex items-center justify-center transition-colors">
                    <Phone className="w-5 h-5" />
                  </div>
                  <span>{companyInfo.phone}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactFormModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)}
        formType={formType}
      />
    </>
  );
};

export default CTASection;
